import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_DASHBOARD_STATS_REQUEST = "FETCH_DASHBOARD_STATS_REQUEST";
export const FETCH_DASHBOARD_STATS_SUCCESS = "FETCH_DASHBOARD_STATS_SUCCESS";
export const FETCH_DASHBOARD_STATS_FAILURE = "FETCH_DASHBOARD_STATS_FAILURE";

export const FETCH_DISTRICT_USERS_REQUEST = "FETCH_DISTRICT_USERS_REQUEST";
export const FETCH_DISTRICT_USERS_SUCCESS = "FETCH_DISTRICT_USERS_SUCCESS";
export const FETCH_DISTRICT_USERS_FAILURE = "FETCH_DISTRICT_USERS_FAILURE";

export const FETCH_DISTRICT_TASK_SUBMIT_REQUEST = "FETCH_DISTRICT_TASK_SUBMIT_REQUEST";
export const FETCH_DISTRICT_TASK_SUBMIT_SUCCESS = "FETCH_DISTRICT_TASK_SUBMIT_SUCCESS";
export const FETCH_DISTRICT_TASK_SUBMIT_FAILURE = "FETCH_DISTRICT_TASK_SUBMIT_FAILURE";

// Fetch Stats
export const fetchDashboardStats = () => async (dispatch) => {
  dispatch({ type: FETCH_DASHBOARD_STATS_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/getDashboardStats`, {
      headers: { authorization: token },
    });
    dispatch({ type: FETCH_DASHBOARD_STATS_SUCCESS, payload: response.data.data });
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_DASHBOARD_STATS_FAILURE, payload: message });
  }
};

// Fetch District-wise Users
export const fetchDistrictUsers = () => async (dispatch) => {
  dispatch({ type: FETCH_DISTRICT_USERS_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/getDistrictWiseUser`, {
      headers: { authorization: token },
    });
    dispatch({ type: FETCH_DISTRICT_USERS_SUCCESS, payload: response.data.data });
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_DISTRICT_USERS_FAILURE, payload: message });
  }
};

// Fetch District-wise Task Submit
export const fetchDistrictTaskSubmit = () => async (dispatch) => {
  dispatch({ type: FETCH_DISTRICT_TASK_SUBMIT_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/getDistrictWiseUserTaskSubmit`, {
      headers: { authorization: token },
    });
    dispatch({ type: FETCH_DISTRICT_TASK_SUBMIT_SUCCESS, payload: response.data.data });
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_DISTRICT_TASK_SUBMIT_FAILURE, payload: message });
  }
};
